import { jsx } from "react/jsx-runtime";
import MuiPagination from "@mui/material/Pagination";
import { useTheme, useMediaQuery } from "@mui/material";
function Pagination({
  siblingCount,
  size,
  ...props
}) {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  return /* @__PURE__ */ jsx(MuiPagination, { ...props, siblingCount: matches ? 0 : siblingCount, size: matches ? "small" : size });
}
export {
  Pagination
};
//# sourceMappingURL=index.js.map
